import React from "react";
import { useQuery } from "react-query";

import { useCommonHooks } from "..";

export function useCategoryRef() {
  const { apis } = useCommonHooks();
  const { data, isFetching, refetch } = useQuery(
    "ref-categories",
    async () => {
      return apis.referential.categories();
    },
    { staleTime: Infinity }
  );

  return {
    categories: data,
    categoriesLoading: isFetching,
    refetchCategories: refetch,
  };
}
